import { t } from '../i18n.ts';
import { h } from './dom.ts';

const frames = (n: number): Promise<void> => new Promise((done) => {
  const step = (): void => {
    if (--n <= 0) done();
    else requestAnimationFrame(step);
  };
  requestAnimationFrame(step);
});

/**
 * A tap on Join answers at once: a dark veil saying where you are going covers the screen while the room
 * connects and the battle builds (which freezes a phone for a moment), and lifts once the battle has drawn.
 * If the room was gone or full, it lifts as the toast says so.
 */
export const entering = async (where: string, go: () => Promise<void> | void): Promise<void> => {
  const veil = h('div.entering', { role: 'status', 'aria-live': 'polite', 'data-test': 'entering' }, h('b.en-title', {}, t('party.joining')), h('p.en-where', {}, where), h('span.be-dots', {}, h('i'), h('i'), h('i')));
  document.body.append(veil);
  // Painted before the heavy part starts.
  await frames(2);
  try {
    await go();
  } finally {
    await frames(2);
    veil.classList.add('out');
    window.setTimeout(() => veil.remove(), 300);
  }
};
